import React from "react";
import Dialog from "material-ui/Dialog";
import FlatButton from "material-ui/FlatButton";
import PropTypes from "prop-types";
// import ReactDisqusThread from "react-disqus-thread";
import sanitizeHtml from "sanitize-html";
import Autolinker from "autolinker";
import "./ViewDialog.css";

export default class ViewDialog extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            dialogProps: {
                open:false
            }
        };
        /*window.disqus_config = function() {
            this.callbacks.onReady.push(function(){
                window.dispatchEvent(new Event('resize'));
            });
            this.callbacks.onNewComment.push(function(){
                window.dispatchEvent(new Event('resize'));
            });
        }*/

    }

    closeHandler(){
        this.props.onSubmit(this.state.dialogProps);
    }

    componentWillReceiveProps(newProps) {
        if(newProps.dialogProps.open && !this.state.dialogProps.open){
            this.setState({disqusKeyForReCreate:Math.random()});
        }
        this.setState({dialogProps:newProps.dialogProps});
    }

    componentWillUnmount(){
        // window.history.pushState(null, null, `/${this.props.campaignId}`);
        // window.history.back();
    }

    componentWillMount(){
        //if(this.props.dialogProps.key)
        //    window.history.pushState(null, null, `${this.props.dialogProps.campaignId}/status/${this.props.dialogProps.key}`);
    }

    render() {
        const actions = [
            <FlatButton
                label="닫기"
                primary={true}
                onTouchTap={function (e) {
                    e.preventDefault();
                    this.closeHandler();
                }.bind(this)}
            />
        ];

        return (
            <Dialog
                actions={actions}
                modal={false}
                open={true}
                onRequestClose={this.props.onCloseRequest}
                autoScrollBodyContent={true}
                repositionOnUpdate={true}
            >
                <div className="msg reset" dangerouslySetInnerHTML={{__html: sanitizeHtml(Autolinker.link(this.props.dialogProps.msg),{
                        allowedTags: [ 'h1','h2','h3','h4','h5','h6','b', 'i', 'u', 'em', 'ul', 'ol', 'li', 'strong', 'a', 'p','br' ],
                        allowedAttributes: {
                            'a': [ 'href', 'target' ]
                        }
                    })}}></div>
            </Dialog>
        );
    }

    /*
    generateComment() {
        let comment;
        if (this.props.dialogProps.userKey && this.props.dialogProps.key) {
            console.log(`${this.props.dialogProps.userKey}-${this.props.dialogProps.key}`);
            comment = (
                <div key={`${this.props.dialogProps.userKey}-${this.props.dialogProps.key}`}>
                    <ReactDisqusThread
                        shortname="yah-ac"
                        identifier={`${this.props.dialogProps.userKey}-${this.props.dialogProps.key}`}
                        // title="comment"
                        url="https://yah.ac"
                        // onNewComment={this.handleNewComment}
                    />
                </div>
            )
        } else {
            comment = <span style={{display: 'none'}}></span>
        }
        return comment;
    }
    */
}
ViewDialog.propTypes = {
    dialogProps:PropTypes.object.isRequired,
    onSubmit:PropTypes.func.isRequired
}


// WEBPACK FOOTER //
// ./src/container/campaign/component/ViewDialog.js